<template>
  <v-container
    class="pricing--custom--container"
    v-closable="{ exclude: [customKey, `${customKey}_actions`, `${customKey}_text`], isClosable: true, handler: 'handleCancelEditing'}"
  >
    <v-row
      align="center"
      no-gutters
      style="z-index: 9;"
      :ref="customKey"
      @click="handleEditing"
      @mouseover="handleMouseOver"
      @mouseleave="handleMouseLeave"
    >
      <v-col
        cols="1"
      >
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
            v-on="on"
            :size="$vuetify.breakpoint.lgAndDown ? '12px' : '14px'"
            >{{ icon }}</v-icon>
          </template>
          <span
            v-show="tooltip != null"
          >{{ tooltip }}
          </span>
        </v-tooltip>
      </v-col>
      <template
        v-if="isEditing"
      >
          <v-col
            cols="3"
            class="mr-2"
          >
            <v-input
              class="custom--input"
              :hide-details="true"
            >
              <v-text-field
                type="number"
                outlined
                v-model="price"
                :hide-details="true"
                :height="$vuetify.breakpoint.lgAndDown ? '20px' : '24px'"
              >
              </v-text-field>
            </v-input>
          </v-col>
          <v-col
            cols="3"
          >
          <v-input
            class="custom--input"
            :hide-details="true"
          >
            <v-combobox
              v-model="currency"
              outlined
              :hide-details="true"
              :items="availableCurrencies"
              :height="$vuetify.breakpoint.lgAndDown ? '20px' : '24px'"
              :ref="`${customKey}_combobox`"
            >
              <template
                v-slot:item="data"
              >
                <span
                  ref="menu-content"
                  :class="[ $vuetify.breakpoint.lgAndDown ? 'font--size--xs' : 'font--size--lg' ]"
                >
                  {{ data.item }}
                </span>
              </template>
            </v-combobox>
          </v-input>
          </v-col>
      </template>
      <v-col
        :ref="`${customKey}_text`"
        cols="6"
        v-show="!isEditing"
      >
      <span
        v-if="localPricing.price != null && localPricing.currency != null"
        :class="[ $vuetify.breakpoint.lgAndDown ? 'font--size--xs' : 'font--size--lg' ]"
      >
        {{ price | humanizeNumber }} {{ currency }}
      </span>
      <template
        v-else
      >
        {{ emptyValue }}
      </template>
      </v-col>
      <v-col
        cols="5"
        class="text-right"
        :class="{'visibility--hidden': !isHovered }"
        :ref="`${customKey}_actions`"
        v-if="!isEditing"
      >
          <v-tooltip top
          >
            <template v-slot:activator="{ on }">
              <v-icon
              v-on="on"
              :size="$vuetify.breakpoint.lgAndDown ? '12px' : '14px'"
              @click="handleEditing"
              >
              fas fa-pen
              </v-icon>
            </template>
            <span>{{$t('buttons.edit')}}</span>
          </v-tooltip>
      </v-col>
        <v-col
          cols="4"
          class="text-right"
          align-self="end"
          v-else
        >
          <v-tooltip top
          >
            <template v-slot:activator="{ on }">
              <v-icon
              v-if="isEditing"
              v-on="on"
              class="mr-2"
              :size="$vuetify.breakpoint.lgAndDown ? '14px' : '16px'"
              :color="isValidSave ? 'wrld_black' : 'wrld_grey'"
              :class="{'btn-disable-events': !isValidSave}"
              @click="handleSave"
              >
              fas fa-save
              </v-icon>
            </template>
            <span>{{$t('buttons.save')}}</span>
          </v-tooltip>
          <v-tooltip top
          >
            <template v-slot:activator="{ on }">
              <v-icon
              v-if="isEditing"
              v-on="on"
              :size="$vuetify.breakpoint.lgAndDown ? '14px' : '16px'"
              @click="handleCancelEditing"
              >
              fas fa-times
              </v-icon>
            </template>
            <span>{{$t('buttons.cancel')}}</span>
          </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { vehicleService } from '@/_services'
  export default {
    name: 'ContextItemEditablePricing',
    props: {
      customKey: { type: String, required: true },
      icon: { type: String, default: 'fas fa-coins' },
      tooltip: { type: String, default: null },
      pricing: {
        type: Object,
        default: () => ({
          price: null,
          currency: null
        })
      },
      emptyValue: { type: String, default: null}
    },
    data() {
      return {
        isHovered: false,
        isEditing: false,
        isSelectingCurrencies: false,
        availableCurrencies: [],
        localPricing: {
          price: null,
          currency: null
        }
      }
    },
    mounted () {
      vehicleService.getCurrencyEnum().then((response) => {
        this.availableCurrencies = response.map((currency) => {
          return currency.name
        })
      })
      if (this.pricing != null) {
        this.localPricing = { price: this.pricing.price, currency: this.pricing.currency }
      }
    },
    methods: {
      handleEditing () {
        this.isEditing = true
      },
      handleCancelEditing () {
        if (!this.isSelectingCurrencies) {
          this.isEditing = false
          this.isHovered = false
        } else {
          this.isSelectingCurrencies = false
        }
      },
      handleSave () {
        // this.isEditing = false
        // this.isHovered = false
        this.$emit('save', this.localPricing)
        setTimeout(() => {
          this.$nextTick(() => {
            this.handleCancelEditing()
          })
        }, 100)
      },
      handleMouseOver () {
        this.isHovered = true
      },
      handleMouseLeave () {
        if (!this.isEditing) {
          this.isHovered = false
        }
      },
    },
    computed: {
      price: {
        get () {
          return this.pricing != null ? this.pricing.price : null
        },
        set (value) {
          this.localPricing = { ...this.localPricing, price: value }
          this.$emit('update:prop', { ...this.pricing, price: value })
        }
      },
      currency: {
        get () {
          return this.pricing != null ? this.pricing.currency : null
        },
        set (value) {
          this.isSelectingCurrencies = true
          this.localPricing = { ...this.localPricing, currency: value }
          this.$emit('update:prop', { ...this.pricing, currency: value })
        }
      },
      isValidSave () {
        return this.localPricing.price != null && this.localPricing.price != null && this.localPricing.currency !== '' && this.localPricing.price !== ''
      }
    },
    beforeDestroy() {
      this.isHovered = false
      this.isEditing = false
      this.isSelectingCurrencies = false
    },
  }
</script>

<style lang="scss">
  .pricing--custom--container {
    border-radius: 5px;
    margin-left: -3px;
    padding: 3px 3px 3px 3px !important;
    &:hover {
      background-color: #f2f2f2;
    }
    span {
      color: var(--v-wrld_black-base);
      .font--size--lg {
        font-size: 1.2em !important;
      }
      .font--size--xs {
        font-size: 1em !important;
      }
    }
    .custom--input {
      .v-input__append-inner {
        display: none !important;
      }
      .v-text-field .v-input__control .v-input__slot {
        font-size: 0.8em;
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
      }
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
</style>
